import request from "./../utils/request";

export function getUsers(perPage = 25, page = 1, query, sortBy = "name", sortOrder = "ascend") {
    return request.get("/users/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
            query,
            sortBy,
            sortOrder,
        },
    });
}

export function getOnlineUsers(fields = [], includeMobileUsers, withStatus = true) {
    fields = fields.join(",");
    let url = `/users/list-online-users?fields=${fields}`;
    if (includeMobileUsers) {
        url += "&includeMobileUsers=true";
    }
    if (!withStatus) {
        url += "&withStatus=false";
    } else {
        url += "&withStatus=true";
    }
    return request.get(url, {}).then((res) => res.data);
}

export function getUser(id) {
    return request.get(`/users/user/${id}`);
}

export function createUser(data) {
    return request.post("/users/", data);
}

export function updateUser(id, data) {
    return request.put(`/users/${id}`, data);
}

export function updateMe(data) {
    return request.put(`/users/me`, data);
}

export function updateUserPassword(data) {
    return request.put(`/users/${data.id}/updatePassword`, data);
}

export function deleteUser(id, transferOwnerShipToUserId) {
    return request.delete(`/users/${id}?transferOwnerShipToUserId=${transferOwnerShipToUserId}`);
}

const fetchActiveUserCount = () => {
    return request.get(`/users/active-user-count`).then((res) => res.data.activeUserCount);
};

export function getUsersBySiteId(siteId, perPage = 25, page = 1, query) {
    return request.get(`/users/site/${siteId}/pagination`, {
        params: {
            pageCount: page,
            perPage: perPage,
            query,
        },
    });
}

export function completeTutorial(tutorialKey, completedAllTutorials = false) {
    return request.post(`/users/me/setup-guide/${tutorialKey}`, {
        completedAllTutorials,
    });
}

export const USER_API = {
    fetchActiveUserCount,
    getUsersBySiteId,
    getOnlineUsers,
};
